import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Card } from '../../../../../../packages/utx-access-client/src/react';

export interface CardActivationModalProps {
  onLayout: (event: any) => void;
}

export enum CardActivationStackRoutes {
  Confirm = 'confirm',
  Placed = 'placed'
}

export type CardActivationStackParamList = {
  [CardActivationStackRoutes.Confirm]: CardActivationModalProps & {
    account: string;
    tab?: number;
    record?: Card;
    func?: (cardId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    actionResponse?: any;
    actionError?: any;
    onData?: (data: any) => void;
    refresh?: () => void;
  };
  [CardActivationStackRoutes.Placed]: CardActivationModalProps & {
    account: string;
    tab?: number;
    record?: Card;
    data?: any;
    refresh?: () => void;
  };
};

export type CardActivationStackScreenProps<Screen extends keyof CardActivationStackParamList> = NativeStackScreenProps<
  CardActivationStackParamList,
  Screen
>;
